import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { AnimatedLogo } from "./AnimatedLogo";

const EASE = [0.22, 1, 0.36, 1];

export const IntroSplash = () => {
    const [show, setShow] = useState(() => {
        try {
            return !sessionStorage.getItem("eway-intro-seen");
        } catch {
            return false;
        }
    });

    useEffect(() => {
        if (!show) return undefined;
        const t = setTimeout(() => {
            try {
                sessionStorage.setItem("eway-intro-seen", "1");
            } catch {
                /* ignore */
            }
            setShow(false);
        }, 3050);
        return () => clearTimeout(t);
    }, [show]);

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    key="intro-splash"
                    data-testid="intro-splash"
                    className="bg-grid fixed inset-0 z-[100] flex flex-col items-center justify-center overflow-hidden bg-[#0B0F19]"
                    exit={{ y: "-100%" }}
                    transition={{ duration: 0.65, ease: EASE }}
                >
                    <div
                        className="pointer-events-none absolute left-1/2 top-1/2 h-[26rem] w-[40rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#E61C24]/15 blur-[130px]"
                        aria-hidden="true"
                    />
                    <motion.div
                        initial={{ opacity: 0, scale: 0.82, y: 14 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        transition={{ duration: 0.9, ease: EASE }}
                        className="relative w-60 sm:w-72"
                    >
                        <AnimatedLogo />
                    </motion.div>

                    <div className="relative mt-2 flex overflow-hidden">
                        {"EWAY".split("").map((ch, i) => (
                            <motion.span
                                key={`${ch}-${i}`}
                                initial={{ y: "115%" }}
                                animate={{ y: 0 }}
                                transition={{
                                    duration: 0.6,
                                    delay: 1.15 + i * 0.09,
                                    ease: EASE,
                                }}
                                className="font-display text-4xl font-black tracking-tight text-white sm:text-5xl"
                            >
                                {ch}
                            </motion.span>
                        ))}
                    </div>

                    <motion.p
                        initial={{ opacity: 0, letterSpacing: "0.2em" }}
                        animate={{ opacity: 1, letterSpacing: "0.55em" }}
                        transition={{ duration: 0.7, delay: 1.6, ease: EASE }}
                        className="font-mono mt-3 pl-2 text-xs font-semibold text-slate-300 sm:text-sm"
                    >
                        FIBRE NET
                    </motion.p>

                    <motion.div
                        initial={{ scaleX: 0 }}
                        animate={{ scaleX: 1 }}
                        transition={{ duration: 0.8, delay: 1.85, ease: EASE }}
                        className="mt-5 h-1 w-40 origin-left rounded-full bg-[#E61C24] shadow-[0_0_18px_rgba(230,28,36,0.7)]"
                        aria-hidden="true"
                    />
                </motion.div>
            )}
        </AnimatePresence>
    );
};
